import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import messageService from '../../services/messageService';

export const fetchMessages = createAsyncThunk('messages/fetch', async ({ conversationId, page, limit }, thunkAPI) => {
  try { return { conversationId, ...(await messageService.list(conversationId, { page, limit })) }; } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});
export const sendMessage = createAsyncThunk('messages/send', async ({ conversationId, payload }, thunkAPI) => {
  try { return { conversationId, message: await messageService.create(conversationId, payload) }; } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});
export const markRead = createAsyncThunk('messages/markRead', async ({ conversationId }, thunkAPI) => {
  try { await messageService.markRead(conversationId); return { conversationId }; } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

const initialState = {
  byConv: {}, // { [id]: { items:[], pagination:{}, isLoading:false } }
  isError: false,
  message: '',
};

const messagesSlice = createSlice({
  name: 'supportMessages',
  initialState,
  reducers: {
    socketAppendMessage(state, action) {
      const { conversationId, message } = action.payload || {};
      const convId = conversationId || message?.conversation;
      if (!convId || !message) return;
      const bucket = (state.byConv[convId] = state.byConv[convId] || { items: [], pagination: {} });
      // Deduplicate by message._id
      const exists = bucket.items.some(m => m._id === message._id);
      if (!exists) bucket.items.push(message);
    }
  },
  extraReducers: (b) => {
    b
      .addCase(fetchMessages.pending, (s, a)=>{ const id=a.meta.arg.conversationId; const bkt=(s.byConv[id]=s.byConv[id]||{items:[],pagination:{}}); bkt.isLoading=true; })
  .addCase(fetchMessages.fulfilled, (s, a)=>{ const { conversationId, messages, totalPages, currentPage, total } = a.payload; const bkt=(s.byConv[conversationId]=s.byConv[conversationId]||{items:[],pagination:{}}); bkt.isLoading=false; const next = Array.isArray(messages)? messages : []; const seen=new Set(); bkt.items = next.filter(m=>{ if(!m?._id) return true; if(seen.has(m._id)) return false; seen.add(m._id); return true; }); bkt.pagination={ totalPages, currentPage, total }; })
      .addCase(fetchMessages.rejected, (s, a)=>{ s.isError=true; s.message=a.payload||'Failed to load messages'; })
      .addCase(sendMessage.fulfilled, (s, a)=>{ const { conversationId, message } = a.payload; const bkt=(s.byConv[conversationId]=s.byConv[conversationId]||{items:[],pagination:{}}); bkt.items.push(message); })
      .addCase(markRead.fulfilled, (s, a)=>{ /* no-op for now; could update unread counters in conversations slice via thunk */ });
  }
});

export const { socketAppendMessage } = messagesSlice.actions;
export default messagesSlice.reducer;
